export default {"src":"/_next/static/media/features-my-crate.84d28238.gif","height":300,"width":400};